import { render, staticRenderFns } from "./DayAgendaList.vue?vue&type=template&id=67b82bf7&scoped=true"
import script from "./DayAgendaList.vue?vue&type=script&lang=js"
export * from "./DayAgendaList.vue?vue&type=script&lang=js"
import style0 from "./DayAgendaList.vue?vue&type=style&index=0&id=67b82bf7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b82bf7",
  null
  
)

export default component.exports